﻿import React, { useState, useEffect, Fragment } from "react";
import { formatCurrency } from "../../../../Components/Pages/BookingFlowPage/Scripts/Currency";
import { parseDate } from "../../../../Resources/Scripts/_Shared/parseDate";
import moment from "moment";

export const RadioButtonListWithLabel = (props) => {
    const wrappingClass = `single-step__section single-step__section--radiobuttonlist ${props.modifierClass}`;
    const valueId = props.value
        ? props.value.item.id || props.value.item.Id
        : null;
    const selectedDate = props?.selectedDate?.date
        ? parseDate(props.selectedDate.date)
        : null;
    const formLang = props.formLang;
    const selectedLanguage = props.selectedLanguage;
    const selectedLocale = props.locale;
    const loadingArray = [0, 1, 2, 3];
    const [isExpanded, setIsExpanded] = useState([]);
    const onLockedProductSelected = props.onLockedProductSelected;

    useEffect(() => {
        if (props.options.length === 0) return;
        if (props.productList && props.index === 0)
            props.options.unshift({
                Text: "No product",
                Id: "00000000-0000-0000-0000-000000000000",
            });
        if (
            props.options.filter(
                (singleoption) =>
                    singleoption.id === valueId || singleoption.Id === valueId,
            ).length > 0
        )
            return;

        if (!props.index && !props.productList)
            props.setValue({ ...props.value, item: props.options[0] });
    }, [props.options]);

    const createPromotText = (singleoption, promotion) => {
        let promoTextFirstLine;
        let promoTextSecondLine;
        if (
            (promotion.DiscountPercent === 100 ||
                promotion.DiscountPercent === 50) &&
            promotion.StartAfter
        ) {
            const text =
                promotion.Duration > 1
                    ? formLang.promomonthfree.multipleduration
                    : formLang.promomonthfree.singleduration;
            promoTextFirstLine = text
                .replace("{0}", promotion.StartAfter + promotion.Duration)
                .replace("{1}", promotion.Duration);
            promoTextFirstLine =
                promoTextFirstLine +
                ` ${promotion.DiscountPercent === 100 ? formLang.promomonthfree.forfree : formLang.promomonthfree.halfprice}`;
            promoTextSecondLine = promotion.DiscountValidity?.ValidFrom
                ? `${formLang.promovalid}${promotion.DiscountValidity?.ValidTo ? "" : " " + formLang.promofrom.split(" ")[0]} ${parseDate(promotion.DiscountValidity.ValidFrom, selectedLocale, "L")}${promotion.DiscountValidity?.ValidTo ? "–" + parseDate(promotion.DiscountValidity.ValidTo, selectedLocale, "L") : ""}`
                : "";
        } else {
            promoTextFirstLine = `${formLang.promodiscount} ${Math.round(promotion.DiscountPercent || promotion.DiscountValue)}${promotion.DiscountValue ? " " + singleoption.Currency : "\u202F%"}`;
            promoTextSecondLine = promotion.DiscountValidity?.ValidFrom
                ? `${formLang.promovalid}${promotion.DiscountValidity?.ValidTo ? "" : " " + formLang.promofrom.split(" ")[0]} ${parseDate(promotion.DiscountValidity.ValidFrom, selectedLocale, "L")}${promotion.DiscountValidity?.ValidTo ? "–" + parseDate(promotion.DiscountValidity.ValidTo, selectedLocale, "L") : ""}`
                : promotion.Duration > 0
                  ? `${formLang.promovalid}${promotion.Duration ? (promotion.Duration > 1 ? " " + formLang.promodurations.replace("{0}", promotion.Duration) : " " + formLang.promoduration.replace("{0}", promotion.Duration)) : ""} ${formLang.promofrom} ${promotion.StartAfter + 1}`
                  : "";
        }
        return [promoTextFirstLine, promoTextSecondLine];
    };

    const expandText = (id) => {
        setIsExpanded((prev) => {
            if (prev.includes(id)) {
                return prev.filter((item) => item !== id);
            } else {
                return [...prev, id];
            }
        });
    };

    return (
        <div className={wrappingClass}>
            {props.text && (
                <label className="single-step__section__label">
                    {props.text}
                </label>
            )}
            {props.subText && (
                <label className="single-step__section__label italic">
                    {props.subText}
                </label>
            )}
            {props.options.map((singleoption, index) => {
                let extraPricingText = "";
                if (
                    props.selectedDay &&
                    props.selectedDay > -1 &&
                    singleoption.WeekdayPrices
                ) {
                    const dayPrice =
                        singleoption.WeekdayPrices[props.selectedDay];
                    extraPricingText = dayPrice ? ` - ${dayPrice}` : "";
                }
                const isAfterPriceChangeSingleOption =
                    singleoption.UpcomingPriceChange?.Validity?.ValidFrom &&
                    selectedDate
                        ? moment(
                              singleoption.UpcomingPriceChange?.Validity
                                  ?.ValidFrom,
                          ).isSameOrBefore(selectedDate, "day")
                        : false;
                let startSellingDateText = "";
                const startSellingDate =
                    moment(parseDate(singleoption.StartSellingDate)).add(
                        6,
                        "hours",
                    ) ||
                    (singleoption.LastBookingEnds
                        ? moment(parseDate(singleoption.LastBookingEnds)).add(
                              1,
                              "days",
                          )
                        : null);
                if (
                    startSellingDate &&
                    moment(selectedDate).isBefore(startSellingDate, "day")
                ) {
                    startSellingDateText = `${props.available} ${moment(startSellingDate).locale(selectedLocale).format("L")}`;
                } else if (
                    singleoption.ParkingSpaceStatus &&
                    singleoption.ParkingSpaceStatus === "NOT_AVAILABLE"
                ) {
                    startSellingDateText = `${props.available} –`;
                }
                const availability = props.productList
                    ? singleoption.Availability
                        ? singleoption.Availability > 4
                            ? formLang.free
                            : formLang.few
                        : formLang.full
                    : "";
                const availabilityClass = props.productList
                    ? singleoption.Availability
                        ? singleoption.Availability > 4
                            ? ""
                            : " single-step__section__radio-label__availability--low"
                        : " single-step__section__radio-label__availability--full"
                    : "";
                const noAvailability = props.productList
                    ? singleoption.Availability === 0
                    : false;
                const availabilityFrom =
                    noAvailability && singleoption.AvailabilityFrom
                        ? moment(parseDate(singleoption.AvailabilityFrom))
                              .locale(selectedLocale)
                              .format("L")
                        : "";

                if (
                    availabilityFrom &&
                    selectedDate &&
                    moment(selectedDate).isBefore(
                        parseDate(availabilityFrom),
                        "day",
                    )
                ) {
                    startSellingDateText = `${props.available} ${availabilityFrom}`;
                }
                const singleOptionId = singleoption.id || singleoption.Id;
                const hasPromo =
                    singleoption.Promotions &&
                    singleoption.Promotions.length > 0;
                const descriptionAndNotes =
                    singleoption.Description + singleoption.Notes;
                const newPrice =
                    props.priceTimes && props.priceTimes > 0
                        ? singleoption.optionPrice * props.priceTimes
                        : singleoption.optionPrice
                          ? singleoption.optionPrice
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, " ")
                          : null;
                const expandedDescription = isExpanded.includes(singleOptionId);
                if (props.readOnly) {
                    return (
                        <label
                            key={index}
                            className="single-step__section__radio-wrapper single-step__section__radio-wrapper--readonly"
                        >
                            <span className="single-step__section__radio-label">
                                {singleoption.text}:{" "}
                                {newPrice > 0 && formatCurrency(newPrice)}{" "}
                                {singleoption.currency}
                            </span>
                        </label>
                    );
                }

                const urlParams = new URLSearchParams(window.location.search);
                const verifiedLockedCode = urlParams.get("verifiedLockedCode");
                const verifiedPid =
                    urlParams.get("pid") ?? urlParams.get("pId");

                const isUnlockedByCode =
                    verifiedLockedCode &&
                    verifiedPid &&
                    singleoption.ZoneAndProduct === verifiedPid;

                const isLockedPmc =
                    singleoption.Visibility === "LOCKED" && !isUnlockedByCode;

                return (
                    !props.loading && (
                        <label
                            onMouseEnter={
                                props.productList
                                    ? () =>
                                          !props.scrollEnabled &&
                                          props.setScrollEnabled(true)
                                    : undefined
                            }
                            onKeyDown={
                                props.productList
                                    ? (e) =>
                                          props.scrollEnabled &&
                                          props.setScrollEnabled(false)
                                    : undefined
                            }
                            key={index}
                            className={
                                singleOptionId ===
                                "00000000-0000-0000-0000-000000000000"
                                    ? "single-step__section__radio-wrapper--hide"
                                    : props.productList &&
                                        singleOptionId === valueId
                                      ? "single-step__section__radio-wrapper selected"
                                      : "single-step__section__radio-wrapper"
                            }
                        >
                            <input
                                className="single-step__section__radio-original"
                                type="radio"
                                id={singleOptionId}
                                checked={singleOptionId === valueId}
                                onClick={(e) =>
                                    e.type === "click" &&
                                    e.clientX !== 0 &&
                                    e.clientY !== 0 &&
                                    e.currentTarget.blur()
                                }
                                onChange={() => {
                                    if (isLockedPmc) {
                                        if (onLockedProductSelected) {
                                            onLockedProductSelected(
                                                singleoption,
                                            );
                                        }
                                        return;
                                    }
                                    props.setValue({
                                        ...props.value,
                                        item: singleoption,
                                    });
                                }}
                                disabled={
                                    props.disabled ||
                                    singleoption.disabled ||
                                    startSellingDateText
                                }
                            />
                            <span className="single-step__section__radio-circle" />
                            <span className="single-step__section__radio-label">
                                {singleoption.text ||
                                    singleoption.OverviewText ||
                                    singleoption.Text}
                                {isLockedPmc ? (
                                    <span className="single-step__section__radio-label__locked-icon"></span>
                                ) : (
                                    " "
                                )}
                                {availability ? (
                                    props.availabilityUpdate ? (
                                        <span className="loadingdots"></span>
                                    ) : (
                                        <span
                                            className={
                                                "single-step__section__radio-label__availability" +
                                                availabilityClass
                                            }
                                        >
                                            {availability}
                                        </span>
                                    )
                                ) : null}
                                {!isLockedPmc &&
                                    singleoption.MonthlyPrice != null && (
                                        <span>
                                            {(isAfterPriceChangeSingleOption &&
                                            singleoption.UpcomingPriceChange
                                                ?.MonthlyPrice
                                                ? formatCurrency(
                                                      singleoption
                                                          .UpcomingPriceChange
                                                          ?.MonthlyPrice,
                                                  )
                                                : formatCurrency(
                                                      singleoption.MonthlyPrice,
                                                  )) +
                                                (extraPricingText ?? "") +
                                                " " +
                                                singleoption.Currency}
                                        </span>
                                    )}
                                {newPrice > 0 ? formatCurrency(newPrice) : null}
                                {singleoption.currency}
                            </span>

                            {props.productList && (
                                <Fragment>
                                    {(singleoption.Notes ||
                                        singleoption.Description ||
                                        startSellingDateText ||
                                        extraPricingText) && (
                                        <div>
                                            {descriptionAndNotes &&
                                            ((window.innerWidth < 768 &&
                                                descriptionAndNotes.length >
                                                    80) ||
                                                descriptionAndNotes.length >
                                                    160) ? (
                                                <div
                                                    className={`${expandedDescription ? "expanded" : "truncated"}`}
                                                >
                                                    <span>
                                                        {
                                                            singleoption.Description
                                                        }
                                                    </span>
                                                    <span>
                                                        {singleoption.Notes}
                                                    </span>
                                                    <button
                                                        onClick={() =>
                                                            expandText(
                                                                singleOptionId,
                                                            )
                                                        }
                                                    >
                                                        {expandedDescription
                                                            ? formLang.readless
                                                            : formLang.readmore}
                                                    </button>
                                                </div>
                                            ) : (
                                                <div>
                                                    <span>
                                                        {
                                                            singleoption.Description
                                                        }
                                                    </span>
                                                    <span>
                                                        {singleoption.Notes}
                                                    </span>
                                                </div>
                                            )}
                                            {startSellingDateText && (
                                                <span className="italic">
                                                    {startSellingDateText}
                                                </span>
                                            )}
                                            {extraPricingText && (
                                                <span className="italic">
                                                    {extraPricingText}
                                                </span>
                                            )}
                                        </div>
                                    )}
                                    {singleoption.Id !==
                                        "00000000-0000-0000-0000-000000000000" &&
                                        hasPromo &&
                                        formLang && (
                                            <div>
                                                {singleoption.Promotions.map(
                                                    (promotion, i) => {
                                                        const promoIsValid =
                                                            hasPromo &&
                                                            !!(
                                                                selectedDate &&
                                                                (!promotion
                                                                    .OrderLineValidFromValidity
                                                                    .ValidTo ||
                                                                    moment(
                                                                        parseDate(
                                                                            selectedDate,
                                                                        ),
                                                                    ).isSameOrBefore(
                                                                        parseDate(
                                                                            promotion
                                                                                .OrderLineValidFromValidity
                                                                                .ValidTo,
                                                                        ),
                                                                    )) &&
                                                                moment(
                                                                    parseDate(
                                                                        selectedDate,
                                                                    ),
                                                                ).isSameOrAfter(
                                                                    parseDate(
                                                                        promotion
                                                                            .OrderLineValidFromValidity
                                                                            .ValidFrom,
                                                                    ),
                                                                )
                                                            );
                                                        const promoText =
                                                            createPromotText(
                                                                singleoption,
                                                                promotion,
                                                            );
                                                        return (
                                                            (!selectedDate ||
                                                                promoIsValid) && (
                                                                <div
                                                                    className="promo-with-text"
                                                                    key={
                                                                        "" +
                                                                        (promotion.DiscountPercent ||
                                                                            promotion.DiscountValue) +
                                                                        (promotion.Duration ||
                                                                            1) +
                                                                        i
                                                                    }
                                                                >
                                                                    <img
                                                                        src={`/publicResources/icons/promo/${selectedLanguage}/Promotion2_${selectedLanguage}.svg`}
                                                                    />
                                                                    <div className="discount">
                                                                        <span>
                                                                            {
                                                                                promoText[0]
                                                                            }
                                                                        </span>
                                                                        {promoText[1] && (
                                                                            <span>
                                                                                {
                                                                                    promoText[1]
                                                                                }
                                                                            </span>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            )
                                                        );
                                                    },
                                                )}
                                            </div>
                                        )}
                                </Fragment>
                            )}
                        </label>
                    )
                );
            })}
            {props.productList &&
                props.loading &&
                loadingArray.map((i) => {
                    return (
                        <label
                            key={i}
                            className="single-step__section__radio-wrapper single-step__section__radio-wrapper--loading"
                        >
                            <input
                                className="single-step__section__radio-original"
                                type="radio"
                                checked={false}
                                disabled={true}
                            />
                            <span className="single-step__section__radio-circle" />
                            <span className="single-step__section__radio-label">
                                <span className="loadingdots"></span>
                            </span>
                        </label>
                    );
                })}
        </div>
    );
};
